import { toast } from "sonner";

export const showApiError = (e, fallback = "Something went wrong. Please try again.") => {
  if (e?.kind === "auth") {
    toast.error(e.status === 403 ? e.message || "You don't have permission to manage this feature." : "Your session expired. Please sign in again.");
  } else if (e?.kind === "offline" || e?.kind === "timeout") {
    toast.error("Unable to connect to Xevon services. Please try again later.");
  } else {
    toast.error(e?.message || fallback);
  }
};

export const SkeletonRows = ({ rows = 3, testId }) => (
  <div className="space-y-3" data-testid={testId} role="status" aria-label="Loading">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="h-16 animate-pulse rounded-xl border border-white/5 bg-white/[0.03]" />
    ))}
  </div>
);

export const ErrorNote = ({ message, onRetry, testId }) => (
  <div className="rounded-xl border border-white/10 bg-white/[0.02] px-4 py-4 text-center" data-testid={testId} role="alert">
    <p className="text-sm text-paper-400">{message}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        data-testid={`${testId}-retry`}
        className="mt-3 rounded-full border border-white/20 px-4 py-1.5 text-xs font-semibold text-paper-100 transition-colors duration-300 hover:bg-white hover:text-black"
      >
        Retry
      </button>
    )}
  </div>
);
